// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"column_listContainer__9J0ix","header":"column_header__h_xUq","footerLinks":"column_footerLinks__PWzw_"};